import { CoreLogService } from "../log.service";

/** NetworkInformation */

export enum ConnectionState {
  None,
  Ethernet,
  Wifi,
  /** iOS7 has only Cell status for cellurar network no difference between 2G-4G */
  Cell,
  Cell_2G,
  Cell_3G,
  Cell_4G,
  /** Has internet but type is unknown (Browser has this for Internet) */
  Unknown
}

export interface NetworkInformation {
  /** ist das Gerät momentan online */
  isOnline: boolean;
  /** Aktueller Status der Netzwerkverbindung */
  state: ConnectionState;
}

/** Events online/offline sind in den Events zu finden */
export class NetworkInformationDefault implements NetworkInformation {

  /** NetworkInformation */
  constructor(private _coreLogService: CoreLogService) {
  }
  
  /** ist das gerät momentan online */
  public get isOnline(): boolean {
    if (typeof (navigator) !== "undefined") {
      return navigator.onLine;
    } else {
      return true; // navigator not defined, so say internet is unknown
    }
  }

  /** Zeigt den NetworkInformation an */
  public get state(): ConnectionState {
    let currentState = ConnectionState.None;
    if (!this.isOnline) { // verkürzte prüfung
      return currentState;
    }

    try {
      let connectionType: string = "";
      if (typeof (navigator) !== "undefined") {
        // todo warum kann nicht auf das Plugin cordova-plugin-network-information zugegriffen werden?
        connectionType = navigator["connection"].type;
      }
      switch (connectionType) {
        case "none" /*Connection.NONE*/:
          currentState = ConnectionState.None;
          break;
        case "ethernet" /*Connection.ETHERNET*/:
          currentState = ConnectionState.Ethernet;
          break;
        case "wifi" /*Connection.WIFI*/:
          currentState = ConnectionState.Wifi;
          break;
        case "4g" /*Connection.CELL_4G*/:
          currentState = ConnectionState.Cell_4G;
          break;
        case "3g" /*Connection.CELL_3G*/:
          currentState = ConnectionState.Cell_3G;
          break;
        case "2g" /*Connection.CELL_2G*/:
          currentState = ConnectionState.Cell_2G;
          break;
        case "cellular" /*Connection.CELL*/:
          currentState = ConnectionState.Cell;
          break;
        case "unknown" /*Connection.UNKNOWN*/:
          currentState = ConnectionState.Unknown;
          break;
        default:
          currentState = ConnectionState.Unknown;
          this._coreLogService.error("NetworkInformationDefault.state", "unsupported connectionType", connectionType);
          break;
      }
    } catch (ex) {
      this._coreLogService.error("NetworkInformationDefault.state", "state read Faild", ex);
    }
    return currentState;
  }
}
